// extracted by mini-css-extract-plugin
export default {"rating":"RrYIGwYC9Z","ratingWrapper":"DSAx_2pXAy","ratingValue":"nqJF7GGhIy","ratingStarsContainer":"B2B154krTP","ratingContainer":"OZ1FSRqrO3","ratingContainerEmpty":"zL5wkenUvT"};